import { NgModule } from '@angular/core';
import { LoadingBarComponent } from './loading-bar.component';
import { MdlModule } from '@angular-mdl/core';
import { LoadingBar } from './loading-bar';
import { RouteLoadingBar } from './route-loading-bar';
import { CommonModule } from '@angular/common';

@NgModule({
    imports: [
        CommonModule,
        MdlModule,
    ],
    declarations: [
        LoadingBarComponent,
    ],
    exports: [
        LoadingBarComponent,
    ],
    providers: [
        LoadingBar,
        RouteLoadingBar,
    ],
})
export class LoadingBarModule {
    constructor(routeLoadingBar: RouteLoadingBar) {
        routeLoadingBar.setupRouteLoadingBar();
    }
}
